/**
 * This files mapes our theme-ui theme to the gatsby plugin shadowing configuration concept.
 * Don't worry about it - you should never have to use / touch this file.
 */
import { theme } from "@styles/theme"

export default {
  ...theme,
}
